import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import styled from '@emotion/styled';
import tw from 'twin.macro';
import _ from 'lodash';
import { isWrongInput } from 'utils/helperMethods';
import { priceSimulatorErrorMessages } from 'utils/Enums';

type CopyScenarioProps = {
    visible: boolean;
    closeModal: () => void;
    onCopyConfrimClick: () => void;
    setCopyScenarioName: Function;
    copyScenarioName: string;
    isDuplicateName: boolean;
};

const CopyScenario = ({
    visible,
    closeModal,
    onCopyConfrimClick,
    setCopyScenarioName,
    copyScenarioName,
    isDuplicateName,
}: CopyScenarioProps) => {
    const onCancelClick = () => {
        setCopyScenarioName('');
        closeModal();
    };
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        setErrorMsg(errorMessage());
    }, [copyScenarioName]);

    const errorMessage = () => {
        if (copyScenarioName.length > 50) {
            return priceSimulatorErrorMessages.MAX_LENGTH;
        }
        if (copyScenarioName.length < 3) {
            return priceSimulatorErrorMessages.MIN_LENGTH;
        }
        if (isDuplicateName) {
            return priceSimulatorErrorMessages.DUPLICATE_NAME;
        }

        if (isWrongInput(copyScenarioName)) {
            return priceSimulatorErrorMessages.INVALID_CHAR;
        }
        return '';
    };

    return (
        <StyledModal
            width={300}
            open={visible}
            title=""
            onCancel={closeModal}
            footer={null}
            className="rounded "
            centered
        >
            <div className="flex flex-col">
                <div className="rounded overflow-hidden text-subHeaderColor font-lg mb-3 font-medium">
                    Copy Scenario
                </div>
                <span className="text-fontGray font-xs">Name</span>
                <div className="flex flex-col relative">
                    <input
                        type="text"
                        className=" rounded  border border-purpleFont font-xxs text-fontGray  outline-none px-3 py-1 mb-4"
                        value={copyScenarioName}
                        onChange={(e) => setCopyScenarioName(e.target.value)}
                    />
                    {errorMsg && <span className="text-redTriangle font-xxs absolute -bottom-1"> {errorMsg}</span>}
                </div>
                <div className="flex justify-end font-bold mt-4">
                    <button
                        type="button"
                        className="mr-2 px-6 py-2 rounded cursor-pointer text-purpleFont bg-white border border-purpleFont font-xxs"
                        onClick={onCancelClick}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className={`px-6 py-2 rounded border font-xxs ${
                            errorMsg
                                ? 'cursor-not-allowed bg-borderGrey border-borderGrey text-promoColour'
                                : 'cursor-pointer bg-purpleFont border-purpleFont text-white'
                        } `}
                        onClick={onCopyConfrimClick}
                        disabled={errorMessage.length > 0}
                    >
                        Make a Copy
                    </button>
                </div>
            </div>
        </StyledModal>
    );
};

export default CopyScenario;

const StyledModal = styled(Modal)`
    .ant-modal-title {
        ${tw`text-subHeaderColor`}
    }

    .ant-modal-close-x span svg {
        fill: '#140B1D';
    }

    .ant-modal-header {
        border: 0px;
    }
`;
